
import Title from "@/components/style/Title.vue";

export default {
  components: {Title},
  computed: {
    max() {
      return Math.max(...Object.values(this.months));
    },
    min() {
      return Math.min(...Object.values(this.months).filter(month => month > 0))-5;
    }
  },
  methods: {
    getWidthPercentage(month) {
      return (month - this.min) / (this.max - this.min) * 70;
    }
  },
  props: {
    months: {},
    label: {default: false}
  }
}
